@if (commandPalette.isOpen) {
  <div
    class="fixed inset-0 z-[100] bg-[#0f1f36]/45 backdrop-blur-[2px]"
    (click)="onOverlayClick()"
  >
    <div
      class="mx-auto mt-[10vh] w-[min(700px,92vw)] rounded-2xl border border-white/50 bg-white shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <div class="border-b border-gray-100 px-5 py-4">
        <input
          #commandInput
          type="text"
          class="w-full rounded-xl border border-gray-200 px-4 py-3 text-[16px] font-medium text-gray-800 outline-none focus:border-[#2f4f7b]"
          placeholder="Seite suchen..."
          [ngModel]="commandPalette.query"
          (ngModelChange)="onQueryChange($event)"
          (keydown)="onListKeydown($event)"
          autocomplete="off"
          spellcheck="false"
        />
      </div>

      <div class="max-h-[55vh] overflow-y-auto p-2">
        @if (commandPalette.passengerSearchLoading && commandPalette.query.trim().length > 0) {
          <p class="px-3 py-2 text-xs text-gray-500">Fahrgaeste werden geladen...</p>
        }
        @if (commandPalette.filteredItems.length === 0) {
          <p class="px-3 py-8 text-center text-sm text-gray-500">Keine passenden Seiten gefunden</p>
        } @else {
          @for (item of commandPalette.filteredItems; track item.route; let i = $index) {
            <button
              #resultItem
              type="button"
              class="flex w-full items-center justify-between rounded-xl px-3 py-3 text-left transition"
              [ngClass]="i === commandPalette.selectedIndex ? 'bg-[#2f4f7b] text-white' : 'hover:bg-gray-100 text-gray-800'"
              (click)="navigateTo(item)"
            >
              <div class="flex items-center gap-3">
                <div
                  class="relative flex h-9 w-9 items-center justify-center rounded-xl"
                  [ngClass]="i === commandPalette.selectedIndex ? 'bg-white/20' : 'bg-[#2f4f7b]/10'"
                >
                  <svg-icon
                    [src]="'assets/icons/' + item.icon + '.svg'"
                    [svgStyle]="{ 'width.px': 22, fill: i === commandPalette.selectedIndex ? '#ffffff' : '#2f4f7b' }"
                  ></svg-icon>

                  @if (item.isCreate) {
                    <div class="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full border border-white bg-emerald-500 shadow-sm">
                      <svg-icon
                        src="assets/icons/add.svg"
                        [svgStyle]="{ 'width.px': 9, fill: '#ffffff' }"
                      ></svg-icon>
                    </div>
                  }

                  @if (item.isEdit) {
                    <div class="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full border border-white bg-orange-500 shadow-sm">
                      <svg-icon
                        src="assets/icons/edit.svg"
                        [svgStyle]="{ 'width.px': 9, fill: '#ffffff' }"
                      ></svg-icon>
                    </div>
                  }

                  @if (item.isPassengerCalendarAction) {
                    <div class="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full border border-white bg-yellow-400 shadow-sm">
                      <svg-icon
                        src="assets/icons/calendar.svg"
                        [svgStyle]="{ 'width.px': 9, fill: '#ffffff' }"
                      ></svg-icon>
                    </div>
                  }

                  @if (item.isPassengerTripAction) {
                    <div class="absolute -bottom-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full border border-white bg-violet-500 shadow-sm">
                      <svg-icon
                        src="assets/icons/route.svg"
                        [svgStyle]="{ 'width.px': 9, fill: '#ffffff' }"
                      ></svg-icon>
                    </div>
                  }
                </div>
                <span class="font-semibold">{{ item.label }}</span>
              </div>

              <div class="flex items-center gap-2">
                @if (!item.hideRoute) {
                  <span class="text-xs opacity-80">{{ item.route }}</span>
                }
              </div>
            </button>
          }
        }
      </div>

      <div class="flex items-center justify-between border-t border-gray-100 px-4 py-3 text-xs text-gray-500">
        <span>Enter: Öffnen</span>
        <span>Pfeile: Auswahl, Esc: Schließen</span>
      </div>
    </div>
  </div>
}
